import React from 'react'
import styled from 'styled-components'
import { path } from 'ramda'
import { LoadingComponent, Panel, Theme } from '@pga/pga-component-library'
import LocationMap from '../LocationMap'

const GOOGLE_MAPS_URL = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&v=weekly&libraries=geometry,drawing,places`

export const LocationWrapper = styled(Panel)`
  margin-top: 10px;
  height: ${props => path(['viewConfig', 'locationHeight'], props)}px;
  padding: 0;
  @media screen and (max-width: 767px) {
    height: 500px;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: ${props => path(['viewConfig', 'flexDirection'], props)};
  justify-content: space-between;
  align-content: center;
  width: 100%;
  height: 100%;
  a {
    color: ${Theme.colors.lightBlue};
  }
  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
`

export const Wrapped = styled.div`
  width: 100%;
  flex-basis: ${props => path(['viewConfig', 'flexBasis'], props)}%;
  ${props => path(['viewConfig', 'order'], props) && 'order: 1;'}
  @media screen and (max-width: 767px) {
    flex-basis: 45%;
    order: 1;
  }
`

export default ({ addressInfo, geoloc, sectionName, viewConfig, LocationInfo }) => (
  <LocationWrapper viewConfig={viewConfig}>
    <Content viewConfig={viewConfig}>
      <LocationInfo addressInfo={addressInfo} sectionName={sectionName} viewConfig={viewConfig} />
      {
        geoloc
          ? <LocationMap
            geoloc={geoloc}
            googleMapURL={GOOGLE_MAPS_URL}
            loadingElement={<LoadingComponent />}
            containerElement={<Wrapped viewConfig={viewConfig} />}
            mapElement={<div style={{ height: '100%' }} />}
            isMarkerShown
            urlParams={[addressInfo.name, addressInfo.zip]}
          />
          : null
      }
    </Content>
  </LocationWrapper>
)
